// import { casinoPageData } from "@/lib/data";
import React, { useEffect, useState } from "react";
import { casinoPageData } from "../../lib/data";
import Roulette from "../../assets/images/category/roulette.webp";

// import Roulette from "@/public/assets/icons/category/roulette.webp";
import BlackJack from "../../assets/images/category/blackjack.webp";
import AndarBahar from "../../assets/images/category/andar-bahar.webp";
import Baccarat from "../../assets/images/category/baccarat.webp";
import Lucky7 from "../../assets/images/category/lucky7.webp";
import Cards32 from "../../assets/images/category/32cards.webp";
import Lottery from "../../assets/images/category/lottery.webp";
import Poker from "../../assets/images/category/poker.webp";
import Craps from "../../assets/images/category/craps.webp";
import Mines from "../../assets/images/category/mines.webp";
import SicBo from "../../assets/images/category/sic-bo.webp";
import GameShow from "../../assets/images/category/game-show.webp";
import DragonTiger from "../../assets/images/category/dragon-tiger.webp";
import RNGGames from "../../assets/images/category/rng-games.webp";
import Others from "../../assets/images/category/others.webp";
import Powergames from "../../assets/images/category/powergames.webp";
import ImprovedExperience from "../../assets/images/category/improved-expereince.webp";
import CardGames from "../../assets/images/category/card-games.webp";
import VirtualCardGames from "../../assets/images/category/virtual-card-games.webp";
import InstantGames from "../../assets/images/category/instant-games.webp";
import Kingmaker from "../../assets/images/category/kingmaker.webp";
import Spribe from "../../assets/images/category/spribe.webp";
import NetEnt from "../../assets/images/category/netent.webp";
import RedTiger from "../../assets/images/category/red-tiger.webp";
import Jili from "../../assets/images/category/jili.webp";
import HacksawGaming from "../../assets/images/category/hacksaw.webp";
import TurboGames from "../../assets/images/category/turbo.webp";
import PlaynGo from "../../assets/images/category/playn-go.webp";
import RelaxGaming from "../../assets/images/category/relax-gaming.webp";
import Habanero from "../../assets/images/category/habanero.webp";
import DragoonSoft from "../../assets/images/category/dragoon-soft.webp";
import HiLo from "../../assets/images/category/hi-lo.webp";
import CrashX from "../../assets/images/category/crash-x.webp";
import Crash from "../../assets/images/category/craps.webp";
import TeenPatti from "../../assets/images/category/teen-patti.webp";

import { useNavigate } from "react-router-dom";

export const STATIC_CATEGORIES = [
  { id: 38, img: Roulette, name: "All", category: "all" },
  { id: 0, img: Roulette, name: "Roulette", category: "roulette" },
  { id: 1, img: BlackJack, name: "BlackJack", category: "blackjack" },
  { id: 2, img: AndarBahar, name: "Andar Bahar", category: "andarbahar" },
  { id: 3, img: Baccarat, name: "Baccarat", category: "baccarat" },
  { id: 4, img: Lucky7, name: "Lucky7", category: "lucky7" },
  { id: 5, img: Cards32, name: "32 Cards", category: "cards32" },
  { id: 6, img: Lottery, name: "Lottery", category: "lottery" },
  { id: 7, img: Poker, name: "Poker", category: "poker" },
  { id: 8, img: Craps, name: "Craps", category: "craps" },
  { id: 9, img: Mines, name: "Mines", category: "mines" },
  { id: 10, img: SicBo, name: "Sic Bo", category: "sicbo" },
  { id: 11, img: GameShow, name: "Game Show", category: "gameshow" },
  { id: 12, img: DragonTiger, name: "Dragon Tiger", category: "dragontiger" },
  { id: 13, img: RNGGames, name: "RNG Games", category: "rngames" },
  { id: 14, img: Others, name: "Others", category: "others" },
  { id: 15, img: Powergames, name: "Powergames", category: "powergames" },
  {
    id: 16,
    img: ImprovedExperience,
    name: "Improved Experience",
    category: "improvedExperience",
    class: "w_100",
  },
  { id: 17, img: CardGames, name: "Card Games", category: "cardGames" },
  {
    id: 18,
    img: VirtualCardGames,
    name: "Virtual Card Games",
    category: "virtualCardGames",
    class: "w_100",
  },
  {
    id: 19,
    img: InstantGames,
    name: "Instant Games",
    category: "instantGames",
  },
  { id: 20, img: Kingmaker, name: "Kingmaker", category: "kingmaker" },
  { id: 21, img: Spribe, name: "Spribe", category: "spribe" },
  { id: 22, img: NetEnt, name: "NetEnt", category: "netent" },
  { id: 23, img: RedTiger, name: "Red Tiger", category: "redtiger" },
  { id: 24, img: Jili, name: "Jili", category: "jili" },
  {
    id: 25,
    img: HacksawGaming,
    name: "Hacksaw Gaming",
    category: "hacksaw",
    class: "w_100",
  },
  { id: 26, img: TurboGames, name: "Turbo Games", category: "turbo" },
  { id: 27, img: PlaynGo, name: "Play'n Go", category: "playNGo" },
  { id: 28, img: RelaxGaming, name: "Relax Gaming", category: "relaxGaming" },
  { id: 29, img: Habanero, name: "Habanero", category: "habanero" },
  { id: 30, img: DragoonSoft, name: "Dragoon Soft", category: "dragoonSoft" },
  // { id: 31, img: Lucky777, name: "Lucky 777", category: "lucky777" },
  { id: 32, img: HiLo, name: "Hi Lo", category: "hiLo" },
  { id: 33, img: CrashX, name: "Crash X", category: "crashX" },
  { id: 34, img: Others, name: "Others", category: "others" },
  { id: 35, img: Crash, name: "Crash", category: "crash" },
  { id: 36, img: TeenPatti, name: "Teen Patti", category: "teenpatti" },
  {
    id: 37,
    img: GameShow,
    name: "Live Game Shows",
    category: "liveGameShows",
    class: "w_100",
  },
];
const CasinosAllGames = ({ defaultCategory = null, search }) => {
  const navigate = useNavigate();
  const [categoryKey, setCategoryKey] = useState(defaultCategory || "roulette");
  const alldData = Object.values(casinoPageData || {})
    .map((item) => Object.values(item))
    .flat()
    .map((item) => Object.values(item))
    .flat();

  useEffect(() => {
    const categoryTab = document.getElementById("active");

    if (categoryTab) {
      categoryTab.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [categoryKey]);
  return (
    <>
      <div className="tabs categories">
        {STATIC_CATEGORIES?.map((item, idx) => {
          return (
            <div
              key={idx}
              onClick={() => {
                setCategoryKey(item?.category);
              }}
              id={categoryKey === item.category ? "active" : ""}
              className={`tab ${item.class || ""} ${
                categoryKey === item.category ? "active" : ""
              }`}>
              <img src={item.img} alt={item.name} />
              {item?.name}
            </div>
          );
        })}
      </div>

      <div className="game-list">
        {Object.values(alldData)
          ?.filter((item) =>
            categoryKey === "all" ? item : item?.category === categoryKey,
          )
          ?.filter((item) =>
            search
              ? item?.name?.toLowerCase().includes(search?.toLowerCase())
              : true,
          )
          .map((item, index) => {
            return (
              <div
                className="game"
                key={index}
                onClick={() => navigate(item?.href)}>
                <div className="first-line"></div>
                <div className="second-line"></div>
                <div className="third-line"></div>
                <div className="fourth-line"></div>
                <img
                  src={item.imgUrl}
                  alt={item.alt}
                  width={200}
                  height={150}
                />
                <div className="overlay"></div>
                {/* <p>{item.name}</p> */}
              </div>
            );
          })}
      </div>
    </>
  );
};

export default CasinosAllGames;
